// extracted by mini-css-extract-plugin
module.exports = {"wdbfgia":"wdbfgia","s1s8l8ml":"s1s8l8ml"};